<template>
  <table>
    <thead>
      <tr>
        <th>Part ID</th>
        <th>Field</th>
        <th>Error</th>
        <th>Current value</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="participantError in errors">
        <tr v-for="error in participantError.errors">
          <td>
            {{ participantError.id }}
          </td>
          <td>
            {{ error.field }}
          </td>
          <td>{{ error.error }}</td>
          <td>{{ error.value || "Empty" }}</td>
          <td>
            <div class="btn-wrap">
              <button
                class="btn-secondary"
                @click="fixParticipantForm.initForm(participantError, error)"
              >
                Fix
              </button>
            </div>
            <div class="btn-wrap" v-if="error.can_be_ignored">
              <button
                class="btn-secondary"
                @click="ignoreParticipantError(participantError, error)"
              >
                Ignore
              </button>
            </div>
            <div class="btn-wrap">
              <button
                class="btn-alert"
                @click="destroyParticipant(participantError.id)"
              >
                Delete
              </button>
            </div>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import {
  DESTROY_ALL_PARTICIPANTS,
  DESTROY_PARTICIPANT,
  UPDATE_PARTICIPANT
} from "@/store/actions.type";

export default {
  name: "RoeParticipantsErrorList",
  props: {
    errors: {
      type: Array
    },
    fixParticipantForm: {}
  },
  methods: {
    destroyParticipant(id) {
      this.$store.dispatch(DESTROY_PARTICIPANT, {
        id: id,
        reportId: this.$router.currentRoute.params.id
      });
    },
    destroyAllParticipants() {
      this.$store.dispatch(
        DESTROY_ALL_PARTICIPANTS,
        this.$router.currentRoute.params.id
      );
    },
    ignoreParticipantError(participantError, error) {
      this.$store.dispatch(UPDATE_PARTICIPANT, {
        reportId: this.$router.currentRoute.params.id,
        params: {
          id: participantError.id,
          ignore: error.attribute
        }
      });
    }
  }
};
</script>
